module.exports = "<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-redo\"></i>&nbsp;端末再起動</h2>\n  </div>\n</md-toolbar>\n<div class=\"sa-reboot-item sa-reboot-item-end\" ng-repeat=\"device in $ctrl.devices\">\n  <sa-reboot-item device=\"device\" mode=\"end\"></sa-reboot-item>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/dev/app/sa_reboot/end_user/sa_reboot.html
// module id = 846
// module chunks = 0